import React from 'react';
import './InfoPanel.css';

export interface InfoItem {
    label: string;
    value: string | number | string[];
    valueColor?: string;
}

interface InfoPanelProps {
    items: InfoItem[];
    className?: string;
}

const InfoPanel: React.FC<InfoPanelProps> = ({ items, className = '' }) => {
    const renderValue = (value: InfoItem['value']) => {
        if (Array.isArray(value)) {
            return value.map((item, idx) => (
                <React.Fragment key={idx}>
                    {item}
                    {idx < value.length - 1 && <br />}
                </React.Fragment>
            ));
        }

        if (typeof value === 'string' && value.includes('\n')) {
            return <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>;
        }

        return value;
    };

    return (
        <div className={`info-panel ${className}`}>
            {items.map((item, index) => (
                <div key={`${item.label}-${index}`} className="info-row">
                    <div className="info-label">
                        {item.label}
                    </div>
                    <div className="info-value" style={{color: item.valueColor ?? "#000000"}}>
                        {renderValue(item.value)}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InfoPanel;